<template>
    <product-card-layout
        :thumb="'visa.jpg'"
        :name="product.name"
        :offers-count="product.offers && product.offers.length"
        :is-recommended="product.recommended"
        :_expanded-count="expanded"
        :_expanded-limit="expandedLimit"
        @change-expanded-count="expanded = $event"
        @change-expanded-limit="expandedLimit = $event"
    >
        <template v-slot>
            <div class="d-flex flex-column full-height">
                <div class="font-weight-medium text-truncate">
                    <span :title="product.name">
                        {{ product.name }}
                    </span>
                </div>
                <supplier-name-label v-if="isTO1" :supplier-name="product.supplierName" />
            </div>
        </template>
        <template v-slot:priceCol>
            <slot name="price" :offer="minPriceOffer">
                <template v-if="!minPriceOffer.soldOut">
                    <cruise-card-price-block :offer="minPriceOffer" />
                    <v-btn
                        variant="flat"
                        block
                        color="primary"
                        class="mt-2"
                        @click="selectForBooking(product.offers[0])"
                    >
                        {{ $t('book') }}
                    </v-btn>
                </template>
            </slot>
            <div class="text-primary cursor-pointer text-no-wrap mt-2" @click="toggleOffers">
                <span>
                    {{ expanded ? $t('hide') : $t('show') }}
                </span>
                <v-icon color="primary">
                    {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
            </div>
        </template>
        <template v-slot:offers>
            <div v-if="expanded" class="mt-3">
                <visa-offer-card
                    v-for="(offer, offerIndex) in sortedFilteredSlicedOffers"
                    :key="offerIndex"
                    :offer="offer"
                >
                    <template v-slot:price="{offer}">
                        <slot name="price" :offer="offer" />
                    </template>
                </visa-offer-card>
                <v-list-item
                    v-if="expanded === expandedLimit && sortedFilteredOffers.length > expandedLimit"
                    density="compact"
                    class="d-flex justify-center"
                    @click.stop="expand"
                >
                    <v-icon>mdi-chevron-down</v-icon>
                </v-list-item>
            </div>
        </template>
    </product-card-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import DiscountLabel from '@/components/snippets/DiscountLabel.vue'
    import CommissionAmount from '@/components/snippets/CommissionAmount.vue'
    import ProductCardLayout from '~/components/search/ProductCardLayout.vue'
    import CruiseCardPriceBlock from '@/components/cruises/search/offers/CruiseCardPriceBlock.vue'
    import SupplierNameLabel from '@/components/hotels/snippets/SupplierNameLabel.vue'
    import DateFilterSearch from '@/components/snippets/DateFilterSearch.vue'
    import {minPriceOffer} from '~/utils/sort-helpers'
    import VisaOfferCard from '@/components/visa/info/VisaOfferCard.vue'

    @Component({
        components: {
            DateFilterSearch,
            SupplierNameLabel,
            CruiseCardPriceBlock,
            CommissionAmount,
            DiscountLabel,
            ProductCardLayout,
            VisaOfferCard,
        },
    })
    export class VisaCard extends Vue {
        @Prop({required: true}) product

        expanded = 0
        expandedLimit = 3
        imgError = false
        dateFilter = null

        expand() {
            this.expanded = this.product.offers.length
            this.expandedLimit = this.product.offers.length
        }

        selectForBooking(offer) {
            visaStore.ADD_TO_BASKET(offer.offerKey)
            this.$router.push({
                name: 'visaBooking',
                query: {offerKey: offer.offerKey},
            })
        }

        toggleOffers() {
            let expanded = 0
            if (!this.expanded) {
                expanded = this.expandedLimit
            }
            this.expanded = expanded
        }

        get datesForFilter() {
            return this.product.offers.map(o => o.startDate)
        }

        get sortedFilteredOffers() {
            return [...this.product.offers]
        }

        get sortedFilteredSlicedOffers() {
            return this.sortedFilteredOffers.slice(0, this.expanded)
        }

        get minPriceOffer() {
            return minPriceOffer(this.product)
        }

        get isTO1() {
            return authStore.isTO1
        }

        get sortKey() {
            return visaStore.sortFnName
        }
    }

    export default VisaCard
</script>

<style scoped lang="scss">
    .short-description {
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
</style>
